import React, { useEffect, useState } from "react";
import { injectModels } from "../redux/injectModels";
import { Routes } from "../constants";
import { Link } from "react-router-dom";

import { routes } from "../constants/routes";
import { toast } from "react-toastify";

function Dashboard(props) {
  const [data, setData] = useState({});
  useEffect(() => {
    getProfile();
  }, []);

  const getProfile = async () => {
    props.application.setLoading(true);
    try {
      const res = await props.admin.getUserProfile();
      if (res.user) {
        const details = res && res.user;
        setData(details);
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };
  return (
    <>
      <main id="main" className="main">
        <div className="pagetitle mb-3">
          <h1>Dashboard</h1>
          <nav>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to={Routes.DASHBOARD}>Home</Link>
              </li>
              <li className="breadcrumb-item active">Dashboard</li>
            </ol>
          </nav>
        </div>
        <section className="section dashboard">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-xxl-4 col-md-6">
                  <div className="card info-card sales-card">
                    <div className="card-body">
                      <h5 className="card-title">
                        <strong className=" small">Total Active Session</strong>
                      </h5>
                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i className="bi bi-amd"></i>
                        </div>
                        <div className="ps-3">
                          <h6>{data.active_sessions_count}</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-xxl-4 col-md-6">
              <div className="card info-card revenue-card">
                <div className="card-body">
                  <h5 className="card-title"><strong className=" small">Total Past Session</strong></h5>
                  <div className="d-flex align-items-center">
                    <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                      <i className="bi bi-award-fill"></i>
                    </div>
                    <div className="ps-3">
                      <h6>20</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
                <div className="col-xxl-4 col-md-6">
                  <div className="card info-card customers-card">
                    <div className="card-body">
                      <h5 className="card-title">
                        <strong className=" small">Total Closed Session</strong>
                      </h5>
                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i className="bi bi-people"></i>
                        </div>
                        <div className="ps-3">
                          <h6>{data.complete_session_count}</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default injectModels(["admin", "application"])(Dashboard);
